const Footer = () => {
  return (
    <div className="footer d-flex justify-content-center w-100 flex-wrap">
      <p className="f-link my-2">Account and list Registry</p>
      <p className="f-link my-2">Sell</p>
      <p className="f-link my-2">About Us</p>
      <p className="f-link my-2">Contact & Customer Service</p>
      <p className="f-link my-2">Privacy Policy</p>
      <p className="f-link my-2">Cookies Policy</p>
      <p className="f-link my-2">Refund & Return Policy</p>
      <p className="f-link my-2">Shipping Policy</p>
      <p className="f-link my-2">Delivery Policy</p>
    </div>
  );
};

export default Footer;
